import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

export const Barcode = ({ value, className = "" }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && value) {
      try {
        JsBarcode(ref.current, value, {
          format: "CODE128",
          displayValue: true,
          fontSize: 18,
          textMargin: 4,
          margin: 10,
          height: 80,
          width: 2.5,
        });
      } catch { /* invalid barcode value */ }
    }
  }, [value]);
  return <svg ref={ref} className={className} />;
};
